import { defaultApi } from '@/plugins/api/defaultApi'

export default {
  name: 'fundaPaygate',
  namespaced: true,
  actions: {
    async getAccountHolderName({}, { bank, accountNumber }) {
      const { data } = await defaultApi.getFundaPaygateAccountHoldername({ bank, accountNumber })
      if (!data || data === '1') {
        const e = new Error()
        e.status = 400
        e.message = '조회된 계좌가 없습니다. <br />계좌번호를 올바르게 입력해주세요'
        throw e
      }
      return data
    },
  },
}
